module.exports = __webpack_public_path__ + "img/bd.67d3790b.svg";